import type { FaireProductEntity } from "../../entity_types/product";

export const p_m76jqkh4t9: FaireProductEntity = {
  token: "p_m76jqkh4t9",
  type: "product",
  name: "Matcha Kansai (Stone Ground Japanese Green Tea) - 100g pouch",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/26954dc41ab8c0e8cf8ccc7578c142c38c879eb1373b18149c81d9d315270f70.png",
  galleryImageUrls: [],
  priceDollars: 29.4,
  description: "A traditional Japanese stone-ground matcha, sourced through our supplier in Kagoshima. Matcha Kansai is named after the region which encompasses the primary prefectures where this tea is grown. The tea bushes are shaded before plucking and the leaves are de-veined and de-stemmed before stone grinding in the traditional way. \n\nThe result is a vibrant, fresh green color and character, with luxurious silky texture. ",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:01.757Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
